/** The `translationKey` an API error carries, when it carries one. */
export function translationKeyOf(error: unknown): unknown {
  return typeof error === 'object' && error !== null
    ? (error as { translationKey?: unknown }).translationKey
    : undefined;
}

/**
 * The request never reached the server: web's `useApi` throws code
 * `OFFLINE` or `NETWORK_ERROR`, mobile's `request()` lets fetch's raw
 * `TypeError` through. A `TIMEOUT` is not one: the server may have done the
 * work.
 */
export function isNetworkError(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false;
  const { status, code } = error as { status?: unknown; code?: unknown };
  if (typeof status === 'number') return false;
  if (code === 'OFFLINE' || code === 'NETWORK_ERROR') return true;
  return error instanceof TypeError;
}
